import { Modal } from "flowbite-react";
import React, { useState } from "react";

export default function ExportReportButton({ handleExport, user }) {
  const [open, setOpen] = useState(false);
  const [emailRecipient, setEmailRecipient] = useState(user?.email || "");

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <button
        className="flex items-center bg-[#3989DD] border text-white rounded py-1.5 px-3 hover:shadow-lg"
        onClick={() => {
          setOpen(true);
        }}
        type="button"
      >
        <span className="px-1 pb-1  pl-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_371_37)">
              <path d="M6 0.5625V7.875" stroke="white" strokeMiterlimit="10" />
              <path
                d="M4.125 2.4375L6 0.5625L7.875 2.4375"
                stroke="white"
                strokeMiterlimit="10"
                // strokeMiterlimit="square"
              />
              <path
                d="M7.5 4.875H9.375C9.62364 4.875 9.8621 4.97377 10.0379 5.14959C10.2137 5.3254 10.3125 5.56386 10.3125 5.8125V10.5C10.3125 10.7486 10.2137 10.9871 10.0379 11.1629C9.8621 11.3387 9.62364 11.4375 9.375 11.4375H2.625C2.37636 11.4375 2.1379 11.3387 1.96209 11.1629C1.78627 10.9871 1.6875 10.7486 1.6875 10.5V5.8125C1.6875 5.56386 1.78627 5.3254 1.96209 5.14959C2.1379 4.97377 2.37636 4.875 2.625 4.875H4.5"
                stroke="white"
                strokeMiterlimit="10"
                // strokeMiterlimit="square"
              />
            </g>
            <defs>
              <clipPath id="clip0_371_37">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>

        <span className="text-base px-1.5 hidden md:block">Export Report</span>
      </button>

      <Modal
        placement={"center"}
        onHide={onClose}
        show={open}
        onClose={onClose}
        size={"sm"}
      >
        <div className="px-4 py-6 flex flex-col gap-6">
          <div>
            <p>Report will be sent to</p>

            <input
              value={emailRecipient}
              onChange={(e) => setEmailRecipient(e.target.value)}
              type="email"
              className="border w-full p-2 rounded mt-2"
              placeholder="Enter email address"
            />
          </div>

          <div className="flex gap-3 item-center justify-end">
            <button
              className=" border rounded py-2 px-7 hover:bg-[#c700001a] hover:text-red-600"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </button>
            <button
              className="text-white bg-[#ff6a3a] hover:bg-[#d85e39] rounded py-2 px-7"
              onClick={() => {
                handleExport?.(emailRecipient);
                onClose();
              }}
              disabled={handleExport === undefined || emailRecipient === ""}
            >
              Export
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
